module.exports = __webpack_public_path__ + "static/media/servicesSecondImage@2x.9ea9519b.jpg";